var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',{attrs:{"dense":_vm.dense}},[_c('v-list-item-group',_vm._l((_vm.selectionItems),function(item,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.emitInput(item)}}},[_c('v-list-item-title',[_vm._v(_vm._s(item.text))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }